import Swiper from "swiper"
import Utils from "./Utility/Utils";
import Framework from "./Framework/Framework"
import CountryScoreCard from "./CountryScoreCard/CountryScoreCard"
import Experience from "./experience/Experience"
import gsap from "gsap"
import $ from 'jquery';
import WorldMap from "./CountryScoreCard/D3WorldMap"
import CountryPanel from "./CountryScoreCard/CountryPanels"
import PolicySimulator from "./PolicySimulator/PolicySimulator"
import SubPage from "./SubPage"
import { PAGE_COUNTRY_SCORE_CARD, PAGE_FRAMEWORK, PAGE_HOMEPAGE, PAGE_POLICY_SIMULATOR } from "./constants"
import MobileCountryDetailSlider from './CountryScoreCard/mobileClasses/CountrySwiperDetail';
import FrameworkMobile from "./Framework/FrameworkMobile";


export class Main {

    constructor(data) {
        this.subPages = Utils.SUB_PAGES
        this.data = data
        this.worldMap = null
        this.countryDetailPanel = null
        this.mobCountryDetailPanel = null

        this.isPortrait = window.innerWidth <= 992

        this.init()
    }

    init() {
        // this.header = document.querySelector('.header').classList.add('active')

        this.experience = new Experience(document.querySelector('canvas.webgl'))
        this.overlaySearchSection = document.querySelector('.experience .section3')
        this.countryScoreBtn = document.querySelector(".section2__link--right")
        this.frameworkBtn = document.querySelector(".section2__link--left")

        this.searchTl = gsap.timeline({ paused: true })
            .to(this.overlaySearchSection, { duration: 1, opacity: 0, visibility: 0 })

        this.regionDropDown = document.querySelector('.experience .left_detail_panel #selectRegion');
        this.isPortrait = window.innerWidth <= 992

        this.countryScoreBtn.addEventListener('click', () => {
            this.handleCountryScore(false)
            SubPage.handleActiveState(2)
        })

        this.frameworkBtn.addEventListener('click', () => {
            this.handleFrameWork()
            SubPage.handleActiveState(4)
        })

        this.handleHomePage()
        this.handleNavigation()
        this.initlizeClasses()

        if (this.isPortrait) {
            this.hamburger_menu = $('.header .hamburger_menu')
            this.mobile_menu_list = $('.mobile_menu')
            this.header = $('.header')
            this.logo = $('.header .logo-panel img')
            this.line = $('.header .logo-panel .line')
            this.ppi_para = $('.header .logo-panel .paragraph')

            this.hamburger_menu.on('click', () => {
                this.handleMobileMenu()
            })
        }


    }

    initlizeClasses() {
        this.policySimulator = new PolicySimulator(this.data)
        
        this.isPortrait ? this.frameworkMobile = new FrameworkMobile() : this.framework = new Framework()
    }



    handleNavigation() {
        if (this.isPortrait) {
            Utils.MOB_NAV_LINKS.forEach((link, i) => {
                link.addEventListener('click', () => {
                    const page = link.dataset.page
                    switch (page) {
                        case PAGE_HOMEPAGE:
                            window.menuHistory.addMenu(PAGE_HOMEPAGE)
                            window.location.reload()
                            break;
                        case PAGE_COUNTRY_SCORE_CARD:
                            this.handleCountryScore()
                            this.frameworkMobile.resetMobFramework()
                            break;
                        case PAGE_POLICY_SIMULATOR:
                            this.handlePolicySimulator()
                            this.frameworkMobile.resetMobFramework()
                            break;
                        case PAGE_FRAMEWORK:
                            this.handleFrameWork()
                            break;

                        default:
                            break;
                    }

                    this.handleMobileMenu()
                })
            })
        } else {
            Utils.NAV_LINKS.forEach((link, i) => {
                link.addEventListener('click', () => {
                    const page = link.dataset.page
                    switch (page) {
                        case PAGE_HOMEPAGE:
                            window.menuHistory.addMenu(PAGE_HOMEPAGE)
                            window.location.reload()
                            break;
                        case PAGE_COUNTRY_SCORE_CARD:
                            this.handleCountryScore()
                            this.framework.resetFramework()
                            break;
                        case PAGE_POLICY_SIMULATOR:
                            this.handlePolicySimulator()
                            this.framework.resetFramework()
                            break;
                        case PAGE_FRAMEWORK:
                            this.handleFrameWork()
                            break;

                        default:
                            break;
                    }
                })
            })
        }
    }


    handleHomePage() {
        this.backBtn = document.querySelectorAll(".regionClose")

        this.experience.resources.on("ready", () => {
            this.worldMap = new WorldMap('map_container', this.data)
            this.countryDetailPanel = new CountryPanel(this.data, this.worldMap)
            this.mobCountryDetailPanel = this.isPortrait ?
                new MobileCountryDetailSlider('.mob_countryDetailSlider', this.countryDetailPanel, this.worldMap, this.data) : null

            if (this.mobCountryDetailPanel) {
                window.mobCountryDetailPanel = this.mobCountryDetailPanel
            }

            this.experience.world.intPlane.on("clicked", (i, region, countries, short, mouse) => {
                processInput({ region: region })
                gsap.to('.webgl', { opacity: 0 })
            })


            // SEARCH INPUT IN GLOBAL MAP
            const searchInput = $(".selectCountryMap")

            this.data.forEach((country) => {
                searchInput.find('.menu').append(`<div class="item" data-value="${country.Region}">${country.Country}</div>`)
            });

            searchInput
                .dropdown({
                    onChange: (value, text, $selectedItem) => {
                        processInput({ region: value, countryName: text })
                        gsap.to('.webgl', { opacity: 0 })
                        if (this.isPortrait) {
                            const activeElement = document.activeElement;

                            // If an input or textarea is focused, blur it to close the keyboard
                            if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
                                activeElement.blur();
                            }
                        }
                    }
                })


            this.backBtn.forEach(btn => {
                btn.addEventListener("click", () => {
                    this.experience.world.earthSphere.particles.morph1()
                    gsap.to(this.experience.camera.instance.position, { z: this.experience.camera.cameraPosition, duration: 1.25, ease: 'power4.inOut' })
                    gsap.to(this.experience.camera.controls.target, { x: 0, y: 0, z: 0, duration: 1.24, ease: 'power4.inOut' })
                    this.experience.intManUpdate = true
                    this.searchTl.reverse()

                    this.worldMap.resetZoom();
                    this.experience.world.intPlane.reverse()
                    this.experience.world.country.reverse()
                    this.countryDetailPanel.hideCountryPanel()
                    searchInput.find('.text').addClass('default').text('Select or search by country')
                    searchInput.find('input[name="country"]').val('')
                    gsap.to('.webgl', { opacity: 1 })
                })
            })

            const processInput = ({ region = null, countryName = null }) => {
                console.log("process: " + countryName)
                // this.experience.world.earthSphere.particles.morph3()
                this.experience.world.intPlane.play()
                this.experience.world.country.play()
                this.experience.intManUpdate = false
                this.searchTl.restart()

                this.countryDetailPanel.showCountryPanel()
                if (!this.isPortrait) {
                    this.countryDetailPanel.updateLeftPanel(region)
                    this.countryDetailPanel.updateRightPanel(region, countryName)
                } else {
                    this.mobCountryDetailPanel.initSlider(region, countryName)
                }

                // Make the world map visible 
                this.worldMap.wrapper.style.opacity = '1';
                this.worldMap.wrapper.style.visibility = 'visible';
                this.worldMap.wrapper.style.pointerEvents = 'auto';
                // Focus the map on the selected region
                this.worldMap.zoomToRegion(region);

                // Listen for region dropdown changes and trigger WorldMap zoom
                if (this.regionDropDown) {
                    this.regionDropDown.addEventListener("change", () => {
                        const selectedRegion = this.regionDropDown.value;
                        this.worldMap.zoomToRegion(selectedRegion); // Trigger zoom in WorldMap
                    });
                } else {
                    console.error("Region dropdown not found!");
                }
            }




        })
    }

    handleCountryScore(status) {
        SubPage.getInstance().resetAll();
        window.menuHistory.addMenu(PAGE_COUNTRY_SCORE_CARD)

        // Common operations for both conditions
        const resetCamera = () => {
            this.experience.world.earthSphere.particles.morph1();
            gsap.to(this.experience.camera.instance.position, { z: this.experience.camera.cameraPosition, duration: 1.25, ease: 'power4.inOut' });
            gsap.to(this.experience.camera.controls.target, { x: 0, y: 0, z: 0, duration: 1.24, ease: 'power4.inOut' });
        };

        const resetWorldElements = () => {
            this.experience.intManUpdate = true;
            this.searchTl.reverse();
            this.worldMap.resetZoom();
            this.experience.world.intPlane.reverse();
            this.experience.world.country.reverse();
            this.countryDetailPanel.hideCountryPanel();
        };

        gsap.to('.webgl', { opacity: 1, duration: 1.24, ease: 'power4.inOut' })




        // Check if we need to navigate or just reset
        if (SubPage.getCurrentPage() != null) {
            resetCamera();
            resetWorldElements();
        }
        this.experience.world.animation.navigateToCountryScoreCard(status);


        // Set the current page to PAGE_COUNTRY_SCORE_CARD
        SubPage.setCurrentPage(PAGE_COUNTRY_SCORE_CARD);
    }


    handlePolicySimulator() {
        SubPage.getInstance().resetAll()
        window.menuHistory.addMenu(PAGE_POLICY_SIMULATOR)
        PolicySimulator.getInstance(this.data).policyScoreGraph.updateGraph('Argentina')
        $('.ui.dropdownPolicy').dropdown('set selected', 'Argentina')
        SubPage.getInstance().showPolicySimulatorPage()
        SubPage.setCurrentPage(PAGE_POLICY_SIMULATOR)
    }

    handleFrameWork() {
        SubPage.getInstance().resetAll()
        window.menuHistory.addMenu(PAGE_FRAMEWORK)
        SubPage.getInstance().showFramworkPage()
        SubPage.setCurrentPage(PAGE_FRAMEWORK)
    }

    handleMobileMenu() {
        Utils.IS_MENU_OPEN = !Utils.IS_MENU_OPEN;
        this.hamburger_menu.toggleClass('active', Utils.IS_MENU_OPEN);
        this.mobile_menu_list.toggleClass('active', Utils.IS_MENU_OPEN)
        this.header.toggleClass('active', Utils.IS_MENU_OPEN)
        this.line.toggle(!Utils.IS_MENU_OPEN)
        this.ppi_para.toggle(Utils.IS_MENU_OPEN)
        this.logo.toggle(!Utils.IS_MENU_OPEN)
    }


}

export default Main